import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye, EyeOff } from 'lucide-react';
import { useBalanceVisibility } from '../contexts/BalanceVisibilityContext';
import HoldingsDisplay from '../components/HoldingsDisplay';
import EnhancedAIArbitrage from '../components/EnhancedAIArbitrage';
import LoyaltyTierProgress from '../components/LoyaltyTierProgress';
import axios from 'axios';

const API_URL = '';

const AIArbitrage = () => {
  const navigate = useNavigate();
  const { balanceVisible, toggleBalanceVisibility, formatBalance } = useBalanceVisibility();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    fetchBalance();
    
    // Auto-refresh balance every 60 seconds for live price updates
    const interval = setInterval(fetchBalance, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchBalance = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      // Fetch portfolio with calculated total balance (live prices)
      const response = await axios.get(`${API_URL}/api/wallet/portfolio`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data) {
        setBalance(response.data);
      }
    } catch (error) {
      console.error('Error fetching balance:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-900 to-slate-800 border-b border-purple-500/30 sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate(-1)}
                className="p-2 hover:bg-slate-700 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-6 h-6 text-purple-400" />
              </button>
              <div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
                  AI Arbitrage
                </h1>
                <p className="text-sm text-gray-400">Automated intelligent trading</p>
              </div>
            </div>
            
            <div className="bg-slate-800/50 px-4 py-2 rounded-lg border border-purple-500/30">
              <HoldingsDisplay 
                showTotal={true}
                showIndividual={false}
                showLastUpdate={false}
                showRefreshButton={true}
                title="AI Trading Balance"
                compact={true}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-6">
        <LoyaltyTierProgress />
        <EnhancedAIArbitrage onBalanceUpdate={fetchBalance} />
      </div>
    </div>
  );
};

export default AIArbitrage;
